<template>
    <div
        class="kgr-inputGroup"
        :class="{ 'with-errors': error.forField('file') }"
    >
        <div class="kgr-inputGroup__label ui-droppable">
            {{ $t('avatar') }}
        </div>

        <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--center kgr-row kgr-row--smallMargin">
            <div
                v-if="hasAvatar"
                class="kgr-postfix__fixed"
            >
                <div class="kgr-profileImage kgr-profileImage--sizeM">
                    <img
                        :src="avatarUrl"
                        :alt="dog.name"
                        class="kgr-profileImage__image"
                    />
                </div>
            </div>
            <div class="kgr-postfix__fluid">
                <template v-if="avatarFile">
                    <kgr-button
                        :value="$t('Foto hochladen')"
                        :pending="pendingUpload"
                        type="blue"
                        @click="uploadAvatar"
                    />
                </template>
                <template v-if="hasAvatar && !avatarFile">
                    <a
                        class="kgr-button kgr-button--small kgr-button--danger"
                        href="javascript:void(0);"
                        @click="deleteAvatar()"
                    >{{ $t('Foto löschen?') }}</a>
                    <input
                        id="check_remove_image"
                        type="hidden"
                        value="0"
                        name="check_remove_image"
                    />
                </template>
            </div>
        </div>
        <kgr-drop-file
            ref="dropFile"
            jpg-png-gif-only
            show-size
            @change="onAvatarChange"
        />

        <div
            v-if="error.forField('file')"
            class="kgr-inputGroup__text kgr-inputGroup__text--error"
        >
            {{ error.messageForField('file') }}
        </div>
        <div class="kgr-inputGroup__text">
            {{ $t('Hier können Sie ein Profilbild einfügen. Die Grafikdatei (z.B. JPG, PNG oder GIF) sollte eine Mindestbreite von 300 Pixel haben und darf eine Dateigröße von 2 MB nicht überschreiten.') }}
        </div>
    </div>
</template>

<script>
import Dog from '../../js/dto/Dog.js';
import DogRepository from '../../js/repository/DogRepository.js';
import DropFile from '../common/form/input/DropFile.vue'
import Error from '../../js/model/Error.js';
import KgrButton from '../common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-drop-file': DropFile,
    },
    props: {
        dog: {
            type: Dog,
            required: true,
        },
    },
    data() {
        return {
            avatarFile: null,
            error: new Error(),
            pendingUpload: false,
            hasAvatar: this.dog.hasAvatar,
            avatarFileName: this.dog.avatarFileName
        }
    },
    computed: {
        avatarUrl() {
            return this.hasAvatar ? DogRepository.avatarUrl(this.dog.id, this.avatarFileName) : kgr.assetsUrls['clubityAvatarDogUnknown'];
        },
    },
    methods: {
        deleteAvatar() {
            showConfirm(this.$t('confirm'), this.$t('Soll das Foto wirklich gelöscht werden?'), () => {
                DogRepository.removeAvatar(this.dog)
                    .then(() => {
                        this.error = new Error();
                        this.hasAvatar = false;
                        this.$forceUpdate();
                        this.$notify.success('Foto erfolgreich gelöscht');
                    })
                    .catch(error => this.handleError(error));
                this.avatarFile = null;
            }, 'Ok');
        },
        onAvatarChange(avatarFile) {
            this.avatarFile = avatarFile;
        },
        uploadAvatar() {
            if (this.avatarFile) {
                this.pendingUpload = true;
                DogRepository.uploadAvatar(this.dog, this.avatarFile)
                    .then(() => {
                        this.error = new Error();
                        this.hasAvatar = true;
                        this.avatarFileName = Date.now();
                        this.avatarFile = null;
                        this.$refs.dropFile.resetFiles();
                        this.$forceUpdate();
                        this.$notify.success('Foto erfolgreich hochgeladen');
                    })
                    .catch(error => this.handleError(error))
                    .finally(() => this.pendingUpload = false)
            }
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
